import { Icon, Intent, Position, ProgressBar, Toaster } from "@blueprintjs/core"
import axios from "axios"
import React, { useState } from "react"
import CustomFileInput from "components/Atoms/CustomFileInput"
import CustomTag from "components/Atoms/CustomTag"
import AppToaster from "utils/AppToaster"
import { useHost } from "global/host.global"
import PreviewTable from "./PreviewTable"
import useAuth, { useFormDisabled } from "hooks/useAuth"
import { get } from "lodash-es"

const UploadToast = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
})

function showToast() {
  AppToaster.show({
    message: "Please upload a valid excel file (.xlsx, .xls)",
    intent: "danger",
    icon: "cross",
  })
}
export default function MultipleDemands() {
  const {
    user: { currentDepartment },
    token,
  } = useAuth()
  const [fileName, changeFileName] = useState("Select File...")
  const [loading, changeLoading] = useState(false)
  // const [isUploaded, changeUploaded] = useState(false);
  const { subdomain, host, protocol } = useHost()
  const [errors, changeErrors] = useState([])
  const disabled = useFormDisabled("demand")
  async function handleChange({ target: { files } }) {
    const currentFile = files && files[0]

    if (!currentFile) return
    if (
      !currentFile.name.includes(".xlsx") &&
      !currentFile.name.includes(".xls")
    ) {
      showToast()
      return
    }

    changeLoading(true)
    const link = `${protocol}://${host}/services/importer/demands/`
    changeFileName(
      currentFile &&
        currentFile.name &&
        `${currentFile.name} - ${currentFile.lastModified}`
    )
    const form = new FormData()
    form.append("file", currentFile)
    form.append("department", get(currentDepartment, "id", null))

    try {
      const response = await axios.post(link, form, {
        headers: {
          Tenant: subdomain,
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: ({ total, loaded }) => {
          const progress = loaded / total
          const percentage = Math.floor(progress * 100)
          UploadToast.show(
            {
              icon: "cloud-upload",
              message: (
                <>
                  <small>{currentFile.name}</small>
                  <ProgressBar
                    className="vt-file-upload-progress"
                    intent={percentage < 100 ? Intent.PRIMARY : Intent.SUCCESS}
                    value={percentage / 100}
                  />
                </>
              ),

              timeout: percentage < 100 ? 0 : 3000,
            },
            currentFile && currentFile.name
          )
        },
      })

      if (response.status === 200) {
        AppToaster.show({
          message: "File Uploaded Successfully",
          intent: "success",
          icon: "tick-circle",
        })
        if (response.data && response.data.data) {
          changeErrors(response.data.data)
          changeLoading(false)
        }
      }
    } catch (error) {
      AppToaster.show({
        message:
          error && error.message
            ? error.message
            : error
            ? error
            : "Something went wrong!",
        intent: "danger",
        icon: "cross",
      })
    }
  }

  const notLive = errors && errors.filter(e => e.status !== "success")
  const live = errors && errors.filter(e => e.status === "success")
  return (
    <div className="vt-multiple-demands">
      <div className="container flex flex-col items-center">
        <div className="w-full flex justify-center items-center flex-col py-8 border-2 border-dotted border-gray-400">
          <Icon iconSize={80} icon="cloud-upload" />
          <h6 className="text-lg mt-4">
            {fileName === "Select File..." ? "Upload" : "Replace"} Excel File
          </h6>
          <CustomFileInput
            disabled={disabled}
            text={fileName}
            onInputChange={disabled ? undefined : (handleChange as any)}
          />
        </div>

        <div className="my-3">
          <CustomTag
            className="ml-6 mr-2"
            large
            round
            minimal
            intent="primary"
            icon="grouped-bar-chart"
          >
            {errors.length} Total
          </CustomTag>
          <CustomTag
            className="mr-2"
            large
            round
            minimal
            intent="success"
            icon="endorsed"
          >
            {live.length} Live
          </CustomTag>
          <CustomTag large round minimal intent="danger" icon="cross">
            {notLive.length} Errors
          </CustomTag>
        </div>
      </div>

      <PreviewTable rows={errors} loading={loading} />
    </div>
  )
}
